<div *ngFor='let message of messageService.messages'>
  <div  class="alert alert-{{ message.status }} alert-dismissible" role="alert">
    <span class="fas fa-{{ message.icon }} mr-3"></span>
    {{ message.message }}
    <button type="button" class="btn-close"
        data-bs-dismiss="alert" aria-label="Close"></button>
  </div>
</div>
